<template>
    <el-dialog
      class="elDialogAdd indexJust"
      :title="title"
      top="0"
      :width="width"
      :visible.sync="visiblePuted"
      :close-on-click-modal="closeOnClickModal"
      :append-to-body="appendToBody"
      @open="open"
      @opened="opened"
      @close="close"
      @closed="closed"
    >
        <slot name="dialogContent"></slot>
    </el-dialog>
</template>

<script>
export default {
    props: {
        // 标题
        title: {
            type: String,
            default: '',
        },
        // 设置宽度
        width: {
            type: String,
            default: '750px',
        },
        // 是否显示 Dialog
        visible: {
            type: Boolean,
            default: false,
        },
        // 是否可以通过点击 modal 关闭 Dialog
        closeOnClickModal: {
            type: Boolean,
            default: true,
        },
        // Dialog 自身是否插入至 body 元素上。嵌套的 Dialog 必须指定该属性并赋值为 true
        appendToBody: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        visiblePuted: {
            get() {
                return this.visible;
            },
            set(nValue) {
                return nValue;
            }
        }
    },
    data() {
        return {}
    },
    methods: {
        open() {
            this.$emit('open');
        },
        opened() {
            this.$emit('opened');
        },
        close() {
            this.$emit('close');
        },
        closed() {
            this.$emit('closed');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/module/dialogEL/index.vue